import { Route, Routes } from "react-router-dom"
import HomeScreen from "../../pages/HomeScreen"

const HomeFlow = () => (
  <Routes>
    <Route index element={<HomeScreen />} />
  </Routes>
)

export default HomeFlow
